import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import {
  WARNING,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST,
  CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";

const ContentReferenceImageRequirements = () => {
  const { t } = useTranslationApp();
  return (
    <Box>
      <Typography color="inherit" variant="body1" sx={{ mb: 2 }}>
        {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENTS_INTRO)}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Box
          component="ul"
          sx={{
            margin: 0,
            paddingLeft: 3,
            listStyle: "unset",
            "& li": {
              mb: 1,
            },
          }}
        >
          <Typography component="li" color="inherit" variant="body2">
            {t(
              CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SAME_COLOR_AND_MODEL
            )}
          </Typography>
          <Typography component="li" color="inherit" variant="body2">
            {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_HIGH_QUALITY)}
          </Typography>
          <Typography component="li" color="inherit" variant="body2">
            {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_PROMINENT)}
          </Typography>
          <Typography component="li" color="inherit" variant="body2">
            {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_SIZE)}
          </Typography>
          <Typography component="li" color="inherit" variant="body2">
            {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_COMPLETE)}
          </Typography>
          <Typography component="li" color="inherit" variant="body2">
            {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_REQUIREMENT_LIGHTING)}
          </Typography>
        </Box>
      </Box>
      <Box component="span" sx={{ fontWeight: 700 }}>
        {t(WARNING)}
      </Box>
      <Typography color="inherit" variant="body2" sx={{ mb: 2, mt: 0.5 }}>
        {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_WARNING_DISTORTION)}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Typography
          color="inherit"
          variant="body1"
          sx={{ fontWeight: 700, mt: 1, mb: 1 }}
        >
          {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_TITLE)}
        </Typography>
        <Typography color="inherit" variant="body2">
          {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_AVOID_LIST)}
        </Typography>
      </Box>
      <Box>
        <Typography
          color="inherit"
          variant="body1"
          sx={{ fontWeight: 700, mt: 1, mb: 1 }}
        >
          {t(CONFIGURATION_PANEL_REFERENCE_IMAGE_EXAMPLES_TITLE)}
        </Typography>
        <Avatar
          src="https://clapp-prod.s3.us-east-1.amazonaws.com/Buzzly/example-input-images.jpeg"
          sx={{ width: "auto", height: "auto", maxWidth: "100%", mb: 1 }}
          variant="square"
        />
        <Avatar
          src="https://clapp-prod.s3.us-east-1.amazonaws.com/Buzzly/example-input-images-2.jpeg"
          sx={{ width: "auto", height: "auto", maxWidth: "100%" }}
          variant="square"
        />
      </Box>
    </Box>
  );
};

export default ContentReferenceImageRequirements;
